// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Addon } from './addon';
import { Image } from './image';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AddonImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK addon */
  addonId!: number;
  /** Int32 FK image */
  imageId!: number;
  /** Boolean */
  isPrimary!: boolean;
  /** Boolean */
  isThumbnail!: boolean;
  /** FK addonId */
  addon!: Addon;
  /** FK imageId */
  image!: Image;
}

